import React from 'react';
import css from './ConfigListing.module.css';
import { Card } from '../../components/Card/Card';

const SectionCard = ({ title, children }) => {
  return (
    <Card>
      <div className={css.cardWrapper}>
        <div className={css.cardHeader}>{title}</div>
        <div className={css.cardContent}>{children}</div>
      </div>
    </Card>
  );
};

export default SectionCard;
